var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 134,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5703 18.8379C43.5703 15.6137 46.1844 13 49.4091 13H87.8917C104.528 13 118.014 26.4844 118.014 43.1182V81.5952C118.014 84.8193 115.4 87.4331 112.176 87.4331H96.9219V75.7573H106.337V43.1182C106.337 32.9327 98.0787 24.6758 87.8917 24.6758H55.2478V81.5952C55.2478 84.8193 52.6337 87.4331 49.4091 87.4331C46.1844 87.4331 43.5703 84.8193 43.5703 81.5952V18.8379Z",
    fill: "#020211"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4456 115.162C84.4456 118.386 81.8315 121 78.6068 121L40.1242 121C23.4879 121 10.0015 107.516 10.0015 90.8818L10.0015 52.4048C10.0015 49.1806 12.6156 46.5669 15.8403 46.5669L31.094 46.5669L31.094 58.2427L21.679 58.2427L21.679 90.8818C21.679 101.067 29.9372 109.324 40.1242 109.324L72.7681 109.324L72.7681 52.4048C72.7681 49.1807 75.3822 46.5669 78.6068 46.5669C81.8315 46.5669 84.4456 49.1807 84.4456 52.4048L84.4456 115.162Z",
    fill: "#020211"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 134,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed22ac9441674f04f3e44f717fb1b497.svg";
export { ForwardRef as ReactComponent };